import * as fromHeader from '../actions/header.action';
import { IHeaderState } from '@app/core/header/models/header-state.model';

export const defaultHeaderState: IHeaderState = {
  counters: { orderLineCount: 0, notificationCount: 0, wishListCount: 0 },
  pageParams: {},
  lastButtonClicked: '',
  meBadge: false
};

export type Action = fromHeader.HeaderActions;
export function reducer(state: IHeaderState = defaultHeaderState, action: Action): IHeaderState {
  switch (action.type) {
    case fromHeader.SET_COUNTERS_NOTIFICATIONS_INCREMENT:
      return {
        ...state,
        counters: {
          orderLineCount: state.counters.orderLineCount,
          notificationCount: state.counters.notificationCount + 1,
          wishListCount: state.counters.wishListCount
        }
      };
    case fromHeader.SET_COUNTERS_NOTIFICATIONS:
      return {
        ...state,
        counters: {
          ...state.counters,
          notificationCount: action.payload
        }
      };
    case fromHeader.SET_COUNTERS_NOTIFICATIONS_RESET:
      return {
        ...state,
        counters: {
          orderLineCount: state.counters.orderLineCount,
          notificationCount: 0,
          wishListCount: state.counters.wishListCount
        }
      };

    case fromHeader.SET_COUNTERS_CART_INCREMENT:
      return {
        ...state,
        counters: {
          orderLineCount: state.counters.orderLineCount + 1,
          notificationCount: state.counters.notificationCount,
          wishListCount: state.counters.wishListCount
        }
      };

    case fromHeader.SET_COUNTERS_CART_DECREMENT:
      return {
        ...state,
        counters: {
          orderLineCount: state.counters.orderLineCount - 1,
          notificationCount: state.counters.notificationCount,
          wishListCount: state.counters.wishListCount
        }
      };

    case fromHeader.SET_COUNTERS_WISHLIST_INCREMENT:
      return {
        ...state,
        counters: {
          orderLineCount: state.counters.orderLineCount,
          notificationCount: state.counters.notificationCount,
          wishListCount: state.counters.wishListCount + 1
        }
      };

    case fromHeader.SET_COUNTERS_WISHLIST_DECREMENT:
      return {
        ...state,
        counters: {
          orderLineCount: state.counters.orderLineCount,
          notificationCount: state.counters.notificationCount,
          wishListCount: state.counters.wishListCount - 1
        }
      };

    case fromHeader.RESET_COUNTERS:
      return { ...state, counters: { orderLineCount: 0, notificationCount: 0, wishListCount: 0 } };

    case fromHeader.SET_COUNTERS_NUMBERS:
      return { ...state, counters: { ...state.counters, ...action.payload } };

    case fromHeader.SET_PAGE_PARAMS:
      return { ...state, pageParams: action.payload };

    case fromHeader.CLICK_ON_HEADER_BUTTON:
      return { ...state, lastButtonClicked: action.payload.button_name };

    case fromHeader.CLICK_ON_ACCESSIBILITY_TOP_LINK:
      return { ...state, eventName: action.payload.event_name };

    case fromHeader.SET_ME_BADGE:
      return { ...state, meBadge: action.payload };

    default:
      return state;
  }
}

export const getCountersNumbers = (state: IHeaderState) => state.counters;
export const getPageParamsState = (state: IHeaderState) => state.pageParams;
export const getMeBadge = (state: IHeaderState) => state.meBadge;
